import { render } from "./HeroiconsSolidUserCircle.vue?vue&type=template&id=0ed5d6c8"
const script = {}

import exportComponent from "/home/nginx/domains/tools.androidrepublic.org/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidUserCircle.vue"]])

export default __exports__